import {Alert, AlertTitle, Typography} from '@mui/material';

import {WINDOWS_TIMEZONES} from '../../../../../const';
import useReportParameters from '../../../../../hooks/providers/useReportParameters';
import {formatNextExecution, getNextExecution} from '../../../../../utils';

const PlannedUpdateBanner = () => {
  const {hasPlannedUpdate, currentReport} = useReportParameters();

  if (!hasPlannedUpdate) return null;

  const schedule = currentReport?.refreshSchedule;
  if (!schedule?.enabled) return null;

  const nextExecution = getNextExecution(schedule);
  if (!nextExecution) return null;

  const label = formatNextExecution(nextExecution);

  const humanizedTimezoneLabel = WINDOWS_TIMEZONES.find(tz => tz.value === schedule.localTimeZoneId)?.label;

  return (
    <Alert
      severity="info"
      sx={{
        mb: 2,
        alignItems: 'center',
        '& .MuiAlert-icon': {
          fontSize: 24
        }
      }}
    >
      <AlertTitle fontSize={14}>Prochaine actualisation planifiée</AlertTitle>
      <Typography fontSize={13} color="text.secondary">
        {label} - {humanizedTimezoneLabel}
      </Typography>
    </Alert>
  );
};

export default PlannedUpdateBanner;
